import { useNavigate } from '@tanstack/react-router';
import { useQueryClient } from '@tanstack/react-query';
import { useState, type FormEvent } from 'react';
import { api, ApiError } from '../api/client';

export function Login() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [totp, setTotp] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api.post('/api/v1/auth/login', { email, password, totp });
      await qc.invalidateQueries();
      void nav({ to: '/' });
    } catch (err) {
      setError(err instanceof ApiError ? (err.status === 423 ? 'Too many attempts. Try again in 15 minutes.' : 'Invalid email, password or code.') : 'Could not sign in.');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="page" style={{ paddingTop: 'calc(20vh + env(safe-area-inset-top))' }}>
      <div className="t-display" style={{ letterSpacing: '0.04em' }}>LORE</div>
      <div className="muted t-sec" style={{ marginBottom: 28 }}>Narrative Intelligence. Autonomous Trading.</div>
      <form onSubmit={(e) => void submit(e)} className="card">
        <div className="field"><label htmlFor="email">Email</label><input id="email" className="input" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required /></div>
        <div className="field"><label htmlFor="password">Password</label><input id="password" className="input" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required /></div>
        <div className="field"><label htmlFor="totp">Authenticator code</label><input id="totp" className="input num" inputMode="numeric" pattern="[0-9]*" autoComplete="one-time-code" value={totp} onChange={(e) => setTotp(e.target.value)} required /></div>
        {error && <div className="loss t-sec" style={{ marginBottom: 12 }}>{error}</div>}
        <button className="btn primary block" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>
    </div>
  );
}
